import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const edit = {
	BlokacePrp: null as boolean | null,
	ProvozovnaId: null as number | null,
	SkladostOzn: null as number | null,
	StrednaklOzn: null as number | null,
	StrednaklOznText: null as string | null,
	Text: null as string | null,
	ZaznamId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[editMutations.SKLAD_PREDMETU_NAKLADOVE_STREDISKO_SELECT_MAPPER](state, { data }) {
			state.edit.StrednaklOzn = data.value;
			state.edit.StrednaklOznText = data.text;
			if (!data.isClear) {
				state.edit.ProvozovnaId = data.provozovnaId;
			}
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
